import { lazy } from "react";

const routes = [
  {
    path: "/profile",
    element: lazy(() => import("../pages/ProfileSetting")),
  },
  {
    path: "/profile/edit/:id",
    element: lazy(() => import("../pages/ProfileSetting/edit")),
  },
];

export default routes;
